import Script from 'next/script'
import { useContext } from 'react'
import useCurrentLocale from '../../../core/hook/useCurrentLocale'
import { ConfigContext } from '../../context/ConfigContext'
import { 
  getIsEuropeWithoutGermanyLocale, 
  getIsGermanyLocale 
} from '../../utils/locale.utils'
import useCurrentStore from '../../../core/hook/useCurrentStore'

const AlmaWidget = ({ amount }) => {
  const { storeConfig } = useContext(ConfigContext)
  const store = useCurrentStore()

  if (!storeConfig) {
    return null
  }

  return (
    <>
      <Script
        src='https://cdn.jsdelivr.net/npm/@alma/widgets@3.x.x/dist/widgets.umd.js'
        onReady={() => {
          const widgets = Alma.Widgets.initialize(
            storeConfig?.alma_api_mode === 'live'
              ? storeConfig?.alma_live_merchant_id
              : storeConfig?.alma_test_merchant_id, // ID marchand (alma_live_merchant_id ou alma_test_merchant_id)
            storeConfig?.alma_api_mode === 'live' ? Alma.ApiMode.LIVE : Alma.ApiMode.TEST, // mode de l'API (LIVE ou TEST)
          )

          const almaPaymentPlans: string = storeConfig?.alma_payment_plans
          const plans =
            almaPaymentPlans && Object.values(JSON.parse(almaPaymentPlans) as Record<string, any>)

          widgets.add(Alma.Widgets.PaymentPlans, {
            container: '#alma-widget',
            purchaseAmount: amount * 100, // Renseigner ici le montant du produit
            locale: store.locale, // Renseigner ici la locale en cours
            hideIfNotEligible: false,
            plans,
          })
        }}
      />
      <div id='alma-widget' />
    </>
  )
}

const KlarnaWidget = ({ amount }) => (
  <>
    <Script
      async
      src='https://eu-library.klarnaservices.com/lib.js'
      data-client-id='b70f955c-9551-5e7f-89a0-422d3c16ad2a'
    />

    <klarna-placement
      id='klarna'
      data-key='credit-promotion-badge'
      data-locale='de-DE'
      data-purchase-amount={amount * 100}
    />
  </>
)

const AffirmWidget = ({ amount }) => {
  const { storeConfig } = useContext(ConfigContext)

  if (!storeConfig) {
    return null
  }

  const { affirm_url_js, affirm_public_key } = storeConfig

  if (!affirm_url_js || !affirm_public_key) {
    return null
  }

  return (
    <>
      <Script id='show-banner'>{`
      _affirm_config = {
        public_api_key: "${affirm_public_key}",
        script: "${affirm_url_js}"
      };
      (function(l,g,m,e,a,f,b){var d,c=l[m]||{},h=document.createElement(f),n=document.getElementsByTagName(f)[0],k=function(a,b,c){return function(){a[b]._.push([c,arguments])}};c[e]=k(c,e,"set");d=c[e];c[a]={};c[a]._=[];d._=[];c[a][b]=k(c,a,b);a=0;for(b="set add save post open empty reset on off trigger ready setProduct".split(" ");a<b.length;a++)d[b[a]]=k(c,e,b[a]);a=0;for(b=["get","token","url","items"];a<b.length;a++)d[b[a]]=function(){};h.async=!0;h.src=g[f];n.parentNode.insertBefore(h,n);delete g[f];d(g);l[m]=c})(window,_affirm_config,"affirm","checkout","ui","script","ready");
      `}</Script>
      <p className='affirm-as-low-as' data-page-type='product' data-amount={amount * 100} />
    </>
  )
}

type ProductPaymentWidgetsProps = {
  amount: number
}

const ProductPaymentWidgets = ({ amount }: ProductPaymentWidgetsProps) => {
  const currentLocale = useCurrentLocale()
  const { storeConfig } = useContext(ConfigContext)
  const { affirm_url_js, affirm_public_key } = storeConfig

  // these values are only setted on american store
  if (affirm_url_js && affirm_public_key) {
    return <AffirmWidget amount={amount} />
  }

  if (getIsGermanyLocale(currentLocale)) {
    return <KlarnaWidget amount={amount} />
  }

  if (getIsEuropeWithoutGermanyLocale(currentLocale)) return <AlmaWidget amount={amount} />
}

export default ProductPaymentWidgets
